import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=d2c3f42e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2c3f42e')) {
      api.createRecord('d2c3f42e', component.options)
    } else {
      api.reload('d2c3f42e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=d2c3f42e&", function () {
      api.rerender('d2c3f42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26K0aBrqqIhnN/JS/comp/IncreaseNumber.vue"
export default component.exports